import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { orderTypeMenuItems } from './constants'

const OrderTypeSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Tipo de pedido')}
      value={value}
      handleChange={e => onChange(e.target.value)}
      menuItems={orderTypeMenuItems.map(o => ({ ...o, label: t(o.label) }))}
    />
  )
}

export default OrderTypeSelector
